import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { InsertNotificationDTO } from 'src/app/helpers/models/add-notification-model';
import { AlertService } from 'src/app/_helpers/alert.service';
import { AuthService } from 'src/app/_services/auth.service';
import { ChatService } from 'src/app/_services/chat_service';
import { RoutingService } from 'src/app/_services/routing.service';
import { UserService } from 'src/app/_services/user.service';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-send-notification',
  templateUrl: './send-notification.component.html',
  styleUrls: ['./send-notification.component.scss']
})
export class SendNotificationComponent implements OnInit {
  insertNotificationDTO: InsertNotificationDTO = new InsertNotificationDTO();

  constructor(
    private _authService: AuthService,
    private _userService: UserService,
    public routing: RoutingService,
    private chatManagement: ChatService,
    private alertService: AlertService,
    private dialogRef : MatDialog
  ) { }

  async ngOnInit() {
  }

  async submitForm(form: NgForm) {
    if (!form.invalid) {
      this.insertNotificationDTO.type = 'promotional';
      this.chatManagement.addNotification(
        this.insertNotificationDTO
      ).subscribe({
        next: (response: any) => {
          this.alertService.show_alert(response.message);
          this.closeDialog();
        },
        error: (errorResponse: any) => {
          this.alertService.show_alert('Something went Wrong!', '', 'error');
        },
      });
    } else {
      this.alertService.show_alert(
        'Please fill all the mandatory fields!',
        '',
        'error'
      );
    }
  }

  closeDialog(){
    this.dialogRef.closeAll();
  }

}
